import SearchableSelect from '@/components/common/SearchableSelect';
import { useCurrencyRegions } from '@/hooks/useCurrencyRegions';
import { inReadingOrder, type CurrencyRegion } from '@/lib/regions';

export default function RegionSelect({
  value,
  onChange,
  regions,
  placeholder = 'Choose a region',
  className,
  testId,
}: {
  value: string;
  onChange: (value: string) => void;
  regions?: CurrencyRegion[];
  placeholder?: string;
  className?: string;
  testId?: string;
}) {
  const fetched = useCurrencyRegions();
  const list = regions ?? fetched.data?.regions ?? [];
  const loading = regions === undefined && fetched.isLoading;

  return (
    <SearchableSelect
      value={value}
      onChange={onChange}
      disabled={loading}
      placeholder={loading ? 'Loading regions…' : placeholder}
      searchPlaceholder="Find a region…"
      emptyText="No regions yet."
      className={className}
      testId={testId}
      options={inReadingOrder(list).map((region) => ({
        value: region.slug,
        label: region.name,
        // The currency sits on the right, so two EUR regions are still telling apart.
        hint: region.currency,
        keywords: `${region.slug} ${region.currency}`,
      }))}
    />
  );
}
